import { defineAsyncComponent } from 'vue'
export default {
  "admin-preview": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/adminPreview.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/empty.vue").then(m => m.default || m))
}